import Header from 'components/header';
import Footer from 'components/footer';
import Container from 'elements/container';
import s from './style.css';
import cn from 'classnames';

const Main = ({ children, includeFooter = true, fullSize }) => (
	<main id="main" className={s.main}>
		<div className={s.header}>
			<Header />
		</div>
		<div className={cn(s.inner, { [s.noFooter]: !includeFooter })}>
			<Container size={fullSize ? 'full' : 'medium'}>{children}</Container>
		</div>
		{includeFooter && (
			<div className={s.footer}>
				<Footer />
			</div>
		)}
	</main>
);

export default Main;



// WEBPACK FOOTER //
// ./layouts/main/index.js